import { RewardScene, EventLayoutProps, RewardType } from '@/types';
import { useReward } from '@/contexts/reward-context';
import { ArrowLeftIcon, CloseIcon } from '@/components/svg-icons';

export const EventLayout = ({ scene, children }: EventLayoutProps) => {
	const { rewardScene, eventListReward, setRewardScene, onClose, labels } = useReward();

	const isShow = (scene === RewardScene.Home || scene === rewardScene);

	const title = {
		[RewardScene.Home]: labels?.lbl_RPSBReward,
		[RewardScene.Rule]: labels?.lbl_RPRulesRegulation,
		[RewardScene.EventList]: labels?.lbl_RPTaskPalace,
		[RewardScene.ExpHistory]: labels?.lbl_RPExperienceLog,
		[RewardScene.RankingRules]: labels?.lbl_RPRulesRegulation,
	}[rewardScene];

	const noTitle = {
		[RewardScene.Ranking]: true,
		[RewardScene.WeeklyAwards]: true,
	}[rewardScene];

	const backScene = {
		[RewardScene.RankingRules]: RewardScene.Ranking
	}[rewardScene];

	let containerClass = {
		[RewardScene.Home]: 'reward-container--main',
		[RewardScene.Rule]: 'reward-single-bg',
		[RewardScene.EventList]: 'reward-container--chlg',
		[RewardScene.ExpHistory]: 'reward-single-bg',
		[RewardScene.Ranking]: '',
		[RewardScene.WeeklyAwards]: '',
		[RewardScene.RankingRules]: 'reward-single-bg',
	}[rewardScene];

	if (rewardScene == RewardScene.EventList) {
		containerClass = {
			[RewardType.Betting]: 'reward-container--chlg-betting',
			[RewardType.Parlay]: 'reward-container--chlg-parlay',
			[RewardType.Streamer]: 'reward-container--chlg-streamer',
			[RewardType.Survey]: 'reward-container--chlg-survey',
			[RewardType.BookedBet]: 'reward-container--chlg-fast'
		}[eventListReward?.RewardType as number];
	}

	const back = () => {
		backScene ? setRewardScene(backScene) : setRewardScene(RewardScene.Home);
	}

	return (
		<div className="reward-main" data-open={isShow}>
			{
				noTitle ? null : (
					<div className="reward-top-bar">
						{
							scene !== RewardScene.Home ?
								<div
									className="reward-top-bar__back"
									onClick={back}
								>
									<ArrowLeftIcon />
								</div> :
								<>
									<div
										className="reward-top-bar__close"
										onClick={onClose}
									>
										<CloseIcon />
									</div>
									<div
										className="reward-top-bar__back"
										onClick={onClose}
									>
										<ArrowLeftIcon />
									</div>
								</>
						}
						<div className="reward-top-bar__title">{title}</div>
					</div>
				)
			}
			<div className={`reward-container reward-scroller ${containerClass ?? ''}`}>
				{children}
			</div>
		</div>
	);
};
